<template>
  <div class="filters-area">
    <p class="list-page-title">Ürünleri Filtrele</p>
    <div class="filters-box">
      <div class="filter-inputs" @keyup.enter="filterEmitter">
        <Input v-model:value="filterProductName" id="product_name" label="Ürün Adı" type="text" />
        <Input v-model:value="filterStockCode" id="stock_code" label="Stok Kodu" type="text" />
        <Input v-model:value="filterProductCode" id="product_code" :minLength="7" v-model:isError="isError" label="Ürün Kodu" type="text" :isOnlyNumber="true"/>
        <Input v-model:value="filterCatalogueId" id="catalog_id" :maxLength="10" label="Katalog ID" type="text" :isOnlyNumber="true"/>
        <Input v-model:value="filterGtin" id="gtin_barcod" :maxLength="14" label="GTIN (Global Barkod)" type="text" :isOnlyNumber="true">
          <template #right-icon>
            <TooltipPlugin tooltipText="Barkod/GTIN, ürünün üzerinde yer alan kod numarasıdır ve her ürün seçeneği (varyant) için tanımlanır.">
              <template #tooltip-btn>
                <Icons name="InfoCircle" color="#7382a0" />
              </template>
            </TooltipPlugin>
          </template>
        </Input>
        <Input v-model:value="filterModelCode" id="model_code" label="Model Kodu" type="text" />
      </div>
        <div class="dropdown-container">
          <DropdownSelectable
            :dropItems="categories"
            @selectedItems="filterCategoryIds = $event"
            label="Kategori Seç"
            notFoundText="Kategori bulunamadı."
            ref="dropdownSelectableCategoriesRef"
            :singleItemTextLength="showApprovalStatusDropdown ? 50 : 80"
          />
          <DropdownSelectable
            :dropItems="brands"
            @selectedItems="filterBrandName = $event"
            label="Marka Seç"
            notFoundText="Marka bulunamadı."
            ref="dropdownSelectableBrandsRef"
            :singleItemTextLength="showApprovalStatusDropdown ? 50 : 80"
          />
          <DropdownSelectable
            v-if="showSenderDropdown"
            :dropItems="senderOptions"
            @selectedItems="sender = $event"
            :isShowSearch="false"
            label= "Gönderici"
            ref="dropdownSelectableSenderRef"
          />
          <DropdownSelectable
            v-if="showApprovalStatusDropdown"
            :dropItems="approvalStatusOptions"
            @selectedItems="selectedStatus = $event"
            :isShowSearch="false"
            :label= "dropdownLabelChangeBySelection"
            ref="dropdownSelectableStatusRef"
          />
          <div class="button-container">
            <AppButton secondary md @click="clear" title="Temizle" :disabled="totalSelections < 1" :style="{ width: '93px' }"></AppButton>
            <AppButton primary md @click="filterEmitter" :title=filterButtonTitle :style="{ width: '90px' }"></AppButton>
          </div>
        </div>

      </div>
    </div>
  </template>

<script>
import { ref, onMounted, computed, watch, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { Input, AppButton, DropdownSelectable, TooltipPlugin, Icons } from '@n11/so-ui-components';
import { ProductStatus } from "../../utils/enum/productStatus";
import { sendProductListFilterEvent } from "@/utils/ga4/helper";
import { TabValueKeys } from "../../utils/enum/productStatus";

export default {
  components: {
    DropdownSelectable,
    AppButton,
    Input,
    TooltipPlugin,
    Icons,
  },
  data() {
    return {
      isError: false,
    };
  },
  props: {
    selectedKey: {
      type: [String, Number],
      required: true
    }
  },
  emits: ['filterEmitter'],
  setup(props, { emit }) {
    const store = useStore();
    const route = useRoute();

    const categories = ref([]);
    const brands = ref([]);
    const filterProductName = ref('');
    const filterStockCode = ref('');
    const filterProductCode = ref('');
    const filterCatalogueId = ref('');
    const filterGtin = ref('');
    const filterModelCode = ref('');
    const filterBrandName = ref([]);
    const filterCategoryIds = ref([]);
    const selectedItems = ref([]);
    const dropdownSelectableCategoriesRef = ref(null);
    const dropdownSelectableBrandsRef = ref(null);
    const dropdownSelectableSenderRef = ref(null);
    const dropdownSelectableStatusRef = ref(null);
    const selectedStatus = ref([]);
    const approvalStatusOptions = ref([]);
    const showApprovalStatusDropdown = ref(false);
    const outOfSaleStatusOptions = ref([]);
    const actionPendingSaleStatusOptions = ref([]);
    const sender = ref([]);

    const senderOptions = ref([
      { id: 0, name: 'n11 Depom' },
      { id: 1, name: 'Mağaza Deposu' }
    ]);

    const getTabParam = computed(() => route.query.tab);

    const getBrands = async () => {
      try {
        const data = await store.dispatch("categories/getBrands");
        return formatBrands(data);
      } catch (error) {
        console.error('Markalar yüklenemedi:', error);
        return [];
      }
    };

    const getCategories = async () => {
      try {
        const data = await store.dispatch("categories/getCategories");
        return data.categories;
      } catch (error) {
        console.error('Kategoriler yüklenemedi:', error);
        return [];
      }
    };

    const updateApprovalStatus = (tabValue) => {
      let pendingActionsOptions = actionPendingSaleStatusOptions.value || [];
      
      if (tabValue === TabValueKeys.WAITING_FOR_ACTION) {
        const hasBrandError = pendingActionsOptions.some(
          (option) => option.id === "BRAND_ERROR"
        );
        if (!hasBrandError) {
          pendingActionsOptions = [
            ...pendingActionsOptions,
            { id: "BRAND_ERROR", name: "Marka Eşleşmesi" },
          ];
        }
      }

      const statusOptions = {
        [TabValueKeys.OUT_OF_SALE]: outOfSaleStatusOptions.value,
        [TabValueKeys.WAITING_FOR_ACTION]: pendingActionsOptions,
      };

      approvalStatusOptions.value = statusOptions[tabValue] || [];
      showApprovalStatusDropdown.value = Boolean(statusOptions[tabValue]);
    };

    const updateSelectedItems = (tabValue) => {
      if (!dropdownSelectableStatusRef.value) return;

      dropdownSelectableStatusRef.value.clearSelection();

      const tabValueToOptionsMap = {
        [TabValueKeys.OUT_OF_SALE]: outOfSaleStatusOptions.value,
        //todo:Atilla
        //[TabValueKeys.WAITING_FOR_ACTION]: [actionPendingSaleStatusOptions.value.find(item => item.id === "InApproval")].filter(Boolean)
        //Anasayfadan gelirken artik inapproval gonderilmedigi icin burasi da simdilik kapatildi products/index.vue onmounted icinde de artik gonderilmiyor.
      };

      const selectedOptions = tabValueToOptionsMap[tabValue] || [];
      dropdownSelectableStatusRef.value.selectedItems.push(...selectedOptions);
    };

    const subTabsByKey = computed(() => store.getters['products/getSubTabsByKey']);

    watch(
      () => props.selectedKey,
      (selectedKey) => {
        outOfSaleStatusOptions.value = subTabsByKey.value?.not_on_sale || [];
        actionPendingSaleStatusOptions.value = subTabsByKey.value?.pending_actions || [];
        updateApprovalStatus(selectedKey);
      },
      { immediate: true }
    );

    onMounted(async () => {
      const [brandsData, categoriesData] = await Promise.all([getBrands(), getCategories()]);
      brands.value = brandsData;
      categories.value = categoriesData;
      outOfSaleStatusOptions.value = subTabsByKey.value?.not_on_sale || [];
      actionPendingSaleStatusOptions.value = subTabsByKey.value?.pending_actions || [];
      updateApprovalStatus(props.selectedKey || getTabParam.value);
      updateSelectedItems(props.selectedKey || getTabParam.value);
    });

    watch(
      () => ({ selectedKey: props.selectedKey, tabParam: route.query.tab }),
      ({ selectedKey, tabParam }) => {
        if (selectedKey !== undefined) {
          updateApprovalStatus(selectedKey);
        }
        if (tabParam !== undefined) {
          updateApprovalStatus(tabParam);
        }
      },
      { immediate: true }
    );

    const totalSelections = computed(() => {
      return (
        (filterProductName.value ? 1 : 0) +
        (filterProductCode.value ? 1 : 0) +
        (filterCatalogueId.value ? 1 : 0) +
        (filterGtin.value ? 1 : 0) +
        (filterModelCode.value ? 1 : 0) +
        (filterStockCode.value ? 1 : 0) +
        (filterCategoryIds.value.length > 0 ? 1 : 0) +
        (filterBrandName.value.length > 0 ? 1 : 0) +
        (sender.value.length > 0 ? 1 : 0) +
        (selectedStatus.value && selectedStatus.value.length > 0 ? 1 : 0)
      );
    });

    const filterButtonTitle = computed(() => {
      return totalSelections.value > 0 ? `Filtrele (${totalSelections.value})` : 'Filtrele';
    });

    const dropdownLabelChangeBySelection = computed(() => {
      return approvalStatusOptions.value.some(item => item.id === "Unlisted") ? 'Onay Durumu':'Hata Etiketi';
    });

    const showSenderDropdown = computed(() => {
      const showInTabs = [
        TabValueKeys.ALL_PRODUCTS,
        TabValueKeys.ON_SALE,
        TabValueKeys.SOLD_OUT,
        TabValueKeys.OUT_OF_SALE
      ];
      return showInTabs.includes(props.selectedKey) || showInTabs.includes(getTabParam.value);
    });

    const filterEmitter = () => {
      const categoryIdsData = filterCategoryIds.value.map(item => item.id);
      const brandsData = filterBrandName.value.map(item => item.name);
      let productStatus = [];
      let inApprovalReason = [];

      if (props.selectedKey === TabValueKeys.OUT_OF_SALE || getTabParam.value === TabValueKeys.OUT_OF_SALE) {
        if (selectedStatus.value.length) {
          const statusIds = selectedStatus.value.map(status => status.id);
          productStatus = statusIds;
        } else {
          productStatus.push(...ProductStatus.OUT_OF_STOCK);
        }
      } else if (props.selectedKey === TabValueKeys.WAITING_FOR_ACTION || getTabParam.value === TabValueKeys.WAITING_FOR_ACTION) {
        if (selectedStatus.value.length) {
          selectedStatus.value.forEach(status => {
             inApprovalReason.push(status.id);
          });
        }
      } else if (props.selectedKey === TabValueKeys.APPROVAL_PENDING) {
        productStatus.push(...ProductStatus.APPROVAL_PENDING);
      } else if (props.selectedKey === TabValueKeys.ALL_PRODUCTS) {
        productStatus.push(...ProductStatus.ALL_PRODUCTS);
      } else if (props.selectedKey === TabValueKeys.ON_SALE) {
        productStatus.push(...ProductStatus.ON_SALE);
      } else if (props.selectedKey === TabValueKeys.SOLD_OUT) {
        productStatus.push(...ProductStatus.ON_SALE);
      } else {
        productStatus.push(...ProductStatus.ALL_PRODUCTS);
      }

      const filterParams = {
        productTitle: filterProductName.value,
        stockCode: filterStockCode.value,
        id: filterProductCode.value,
        pimsId: filterCatalogueId.value,
        brandName: brandsData,
        categoryIds: categoryIdsData,
        gtin: filterGtin.value,
        modelCode: filterModelCode.value,
        productStatus: productStatus,
        productInApprovalReason: inApprovalReason || [],
      };

      if (sender.value.length === 1) {
        if (sender.value[0].id === 0) {
          filterParams.n11Warehouse = true;
        } else if (sender.value[0].id === 1) {
          filterParams.n11Warehouse = false;
        }
      } else {
        filterParams.n11Warehouse = null;
      }

      emit('filterEmitter', filterParams);

      sendProductListFilterEvent({
        product_name: filterProductName.value ? 'Filtered' : 'Not Filtered',
        stock_code: filterStockCode.value ? 'Filtered' : 'Not Filtered',
        catalog_id: filterCatalogueId.value ? 'Filtered' : 'Not Filtered',
        gtin: filterGtin.value ? 'Filtered' : 'Not Filtered',
        model_code: filterModelCode.value ? 'Filtered' : 'Not Filtered',
        product_code: filterProductCode.value ? 'Filtered' : 'Not Filtered',
        category: categoryIdsData?.length ? 'Filtered' : 'Not Filtered',
        brand: brandsData?.length ? 'Filtered' : 'Not Filtered',
      })
    };

    const formatBrands = (data) => {
      return data.map(item => {
        if (typeof item === 'string') {
          return { id: item, name: item };
        } else if (typeof item === 'object' && item !== null) {
          return {
            id: item.id || item.name || 'unknown',
            name: item.name || 'unknown'
          };
        } else {
          return { id: 'unknown', name: 'unknown' };
        }
      });
    };

    const clearFilters = () => {
      filterProductName.value = '';
      filterStockCode.value = '';
      filterProductCode.value = '';
      filterCatalogueId.value = '';
      filterGtin.value = '';
      filterModelCode.value = '';
      filterBrandName.value = [];
      filterCategoryIds.value = [];
      selectedItems.value = [];
      selectedStatus.value = [];
      sender.value = [];

      if (dropdownSelectableCategoriesRef.value) {
        dropdownSelectableCategoriesRef.value.clearSelection();
      }
      if (dropdownSelectableBrandsRef.value) {
        dropdownSelectableBrandsRef.value.clearSelection();
      }
      if (dropdownSelectableSenderRef.value) {
        dropdownSelectableSenderRef.value.clearSelection();
      }
      if (dropdownSelectableStatusRef.value) {
        dropdownSelectableStatusRef.value.clearSelection();
      }
    };

    const clear = () => {
      clearFilters();
      let productStatus = [];
      let inApprovalReason = [];
      if (props.selectedKey === TabValueKeys.OUT_OF_SALE || getTabParam.value === TabValueKeys.OUT_OF_SALE) {
        productStatus.push(...ProductStatus.OUT_OF_STOCK);
      } else if (props.selectedKey === TabValueKeys.WAITING_FOR_ACTION || getTabParam.value === TabValueKeys.WAITING_FOR_ACTION) {
        productStatus = []; //clear oldugunda productStatus temizlenmeli default degeri gonderilmemeli
      } else if (props.selectedKey === TabValueKeys.APPROVAL_PENDING) {
        productStatus.push(...ProductStatus.APPROVAL_PENDING);
      } else if (props.selectedKey === TabValueKeys.ALL_PRODUCTS) {
        productStatus.push(...ProductStatus.ALL_PRODUCTS);
      } else if (props.selectedKey === TabValueKeys.ON_SALE) {
        productStatus.push(...ProductStatus.ON_SALE);
      } else if (props.selectedKey === TabValueKeys.SOLD_OUT) {
        productStatus.push(...ProductStatus.ON_SALE);
      } else {
        productStatus.push(...ProductStatus.ALL_PRODUCTS);
      }

      emit('filterEmitter', {
        productTitle: '',
        id: '',
        stockCode: '',
        pimsId: '',
        brandName: '',
        categoryIds: '',
        gtin: '',
        modelCode: '',
        productStatus: productStatus,
        productInApprovalReason: inApprovalReason,
        n11Warehouse: null,
      });
    };

    const handleKeyUp = (event) => {
      if (event.key === 'Enter' && totalSelections.value > 0) {
        filterEmitter();
      }
    };

    onMounted(() => {
      window.addEventListener('keyup', handleKeyUp);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('keyup', handleKeyUp);
    });
    return {
      filterEmitter,
      filterProductName,
      filterStockCode,
      filterProductCode,
      filterCatalogueId,
      filterGtin,
      filterModelCode,
      filterBrandName,
      filterCategoryIds,
      categories,
      brands,
      clear,
      dropdownSelectableCategoriesRef,
      dropdownSelectableBrandsRef,
      dropdownSelectableSenderRef,
      dropdownSelectableStatusRef,
      senderOptions,
      sender,
      showApprovalStatusDropdown,
      approvalStatusOptions,
      outOfSaleStatusOptions,
      actionPendingSaleStatusOptions,
      selectedStatus,
      formatBrands,
      clearFilters,
      filterButtonTitle,
      handleKeyUp,
      totalSelections,
      updateApprovalStatus,
      updateSelectedItems,
      dropdownLabelChangeBySelection,
      showSenderDropdown,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/utilities.scss';

.list-page-title {
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.05px;
  margin-bottom: 16px;
}

.filters-box {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 24px;
}

.filter-input {
  display: flex;
  border-radius: 6px;
  border: 0.5px solid $colorD30;
  background: #FFF;
  padding: 12px;
  width: 20%;
}

.filter-inputs {
  display: flex;
  gap: 16px;
  align-content: space-between;
  justify-content: space-between;
  height: 40px;
}

input::placeholder {
  color: var(--Dusk---Decorative-D40, #7382A0);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.dropdown-input {
  flex: 1;
  border: 0.5px solid #B3BBCB;
  border-radius: 4px;
  padding: 8px;
  font-size: 16px;
  box-sizing: border-box;
}

.dropdown-container {
  display: flex;
  gap: 16px;
}

.checkbox-label {
  color: #7382A0;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.05px;
  margin: 0;
  padding: 8px;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-left: auto;
}

.primary {
  border-radius: 4px;
  background: var(--Green---Success-G50, #5D3EBC);
  display: flex;
  height: 32px;
  padding: 7px 32px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  color: #FFF;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: -0.05px;
}

.secondary {
  border-radius: 4px;
  background: var($colorD30, #B3BBCB);
  display: flex;
  height: 32px;
  padding: 7px 32px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  color: #FFF;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: -0.05px;
}
</style>
